/**
 * Moonpage 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  avatarBorder: brandTheme.borderPrimary,
  btnPrimaryBg: 'rgba(76, 125, 255, 0.08)',
  topUpBtnBg: 'linear-gradient(90deg, #B4CCFF 0%, #7CA5FF 100%)',
  vipSubscribeBg: 'url(/images/moonpage/member_subscribe_bg.webp)',
  subscribeBg: 'linear-gradient(100deg, #EEF4FF 0%, #E2ECFF 60%, #D7E5FF 100%)',
  subscribeText: '#4D6FC2',
  subscribeText2: 'rgba(77, 111, 194, 0.58)',
  vipBtnBg: brandTheme.primaryGradient || 'linear-gradient(90deg, #8DB8FF 0%, #5E79F6 100%)',
} as const

export const resources = {
  memberBg: '',
  userBg: '',
  userDefaultAvatar: '/images/moonpage/user-default.svg?v=3',
  memberVip: '/images/moonpage/member-vip.png',
  memberVipDiscount: '/images/moonpage/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
